"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconLegalScaleUnequal1 = /*#__PURE__*/
function (_Icon) {
  _inherits(IconLegalScaleUnequal1, _Icon);
  function IconLegalScaleUnequal1(props) {
    var _this;
    _classCallCheck(this, IconLegalScaleUnequal1);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconLegalScaleUnequal1).call(this, props));
    _this.name = 'IconLegalScaleUnequal1';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "legal-scale-unequal-1_svg__group0"
    }, _react2.default.createElement("path", {
      className: "legal-scale-unequal-1_svg__path0",
      d: "M7.5 22.5a.5.5 0 010-1h4V6.241L5.177 8.8l3.276 6.988a.372.372 0 01.032.109c.004.012.01.036.013.066a2.976 2.976 0 01.002.22c-.052 2.105-1.806 3.818-3.908 3.818L4.494 20l-.079.001L4.318 20c-1.046-.026-2.019-.458-2.74-1.216a3.891 3.891 0 01-1.075-2.833c.003-.025.009-.043.012-.053a.41.41 0 01.023-.088l.012-.029 2.957-6.307-.873.355a.499.499 0 01-.648-.659.495.495 0 01.273-.268L11.5 5.163V3.5a.5.5 0 011 0v1.258l.804-.325 7.005-2.895a.497.497 0 01.653.653.5.5 0 01-.271.271l-.519.214 3.282 7.114.012.03c.014.038.019.07.022.09.001.004.008.025.01.054a3.887 3.887 0 01-1.076 2.821 3.894 3.894 0 01-2.74 1.216l-.097.001-.091-.002-.097.001a3.874 3.874 0 01-2.68-1.079 3.894 3.894 0 01-1.216-2.935c0-.018.003-.035.007-.052a.214.214 0 01.008-.034.347.347 0 01.025-.096l2.971-6.443-4.834 1.998-1.178.477V21.5h4a.5.5 0 010 1h-9zm-2.899-3.498a2.905 2.905 0 002.872-2.501H1.528A2.915 2.915 0 004.343 19l.072.001.079-.001.107.002zM7.214 15.5L4.5 9.713 1.787 15.5h5.427zm9.315-5c.092.647.398 1.242.877 1.698a2.892 2.892 0 002.001.804l.107-.001.072.001.071-.002a2.93 2.93 0 002.814-2.5h-5.942zm5.69-1L19.5 3.607 16.782 9.5h5.437z"
    })));
    return _this;
  }
  return IconLegalScaleUnequal1;
}(_Icon3.default);
exports.default = IconLegalScaleUnequal1;